import { useState, useEffect, useCallback } from 'react';
import {
  SweepHeader, SweepProgressBar, SweepItemCard,
  SweepActionGrid, SweepQueuePreview, SweepFooter, SweepExitOverlay,
} from './sweep/SweepParts';

export default function BatchSweepMode({ decisions, onAction, onClose }) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [actionLog, setActionLog] = useState([]);
  const [exiting, setExiting] = useState(false);

  const current = decisions[currentIdx];
  const total = decisions.length;
  const processed = actionLog.length;
  const progress = total > 0 ? (processed / total) * 100 : 0;

  const handleAction = useCallback((action) => {
    if (!current) return;
    setActionLog((prev) => [...prev, { id: current.id, type: current.type, action, title: current.title }]);
    onAction?.(current, action);
    if (currentIdx < total - 1) {
      setCurrentIdx((i) => i + 1);
    } else {
      setExiting(true);
      setTimeout(() => onClose?.(), 600);
    }
  }, [current, currentIdx, total, onAction, onClose]);

  useEffect(() => {
    const handleKey = (e) => {
      if (exiting) return;
      const keyMap = { d: 'do', g: 'delegate', f: 'defer', x: 'archive' };
      const action = keyMap[e.key.toLowerCase()];
      if (action) handleAction(action);
      else if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [handleAction, onClose, exiting]);

  if (!current) return null;

  return (
    <div data-testid="batch-sweep-mode" className="fixed inset-0 z-[300] flex flex-col"
      style={{ background: 'var(--pd-bg)', backdropFilter: 'blur(24px)' }}>
      <SweepHeader processed={processed} total={total} onClose={onClose} />
      <SweepProgressBar progress={progress} />

      <div className="flex-1 flex items-center justify-center px-8">
        <div className="w-full max-w-xl animate-fade-in" key={current.id}>
          <SweepItemCard item={current} />
          <SweepActionGrid onAction={handleAction} />
          <SweepQueuePreview decisions={decisions} currentIdx={currentIdx} />
        </div>
      </div>

      <SweepFooter actionLog={actionLog} />
      {exiting && <SweepExitOverlay processed={processed} />}
    </div>
  );
}
